function getDeviceStoreLink() {

    const userAgent = navigator.userAgent
    
    // Check for iOS devices
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return '';
    }
    
    // Check for Android devices
    if (/android/i.test(userAgent)) {
        return '';
    }
    
    // Default case for other devices
    return '';

}

export default getDeviceStoreLink;